import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/rest_services/user.service';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TeamService } from 'src/app/rest_services/team.service';
import {formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisitService } from 'src/app/rest_services/visit.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
declare var $: any;
declare let swal: any;
declare var NotificationFx:any;
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Subscription } from 'rxjs';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { NotificationsService } from 'src/app/rest_services/notifications.service';


@Component({
  selector: 'app-dash-admin',
  templateUrl: './dash-admin.component.html',
  styleUrls: ['./dash-admin.component.css']
})

export class DashAdminComponent implements OnInit {
  jHERE:any;
  dashloading:boolean=true;
  programmLoading:boolean =true;
  rapportLoading:boolean =true;
  loginRequest:any;
  prospects:String="";
  customers:String="";
  commercial:String="";
  datevisite:Date= new Date();
  company:String="";
  token:any = '';

  news: any[]=[];
  commercial_name:string="";
  commercial_avatar:any="";
  date_publication:string="";
  report_of_action:string="";
  report_customer:string="";
  report_desc:string="";
  report:string="";
  detailrapport:any={};
  
  commercials:any[] = [];
  customer:any[] = [];

  visit_management_message: FormGroup;

  actions_plan_members: FormGroup;
  actions_plan_customers!: FormGroup;
  
  counter: number = 0;
  constructor(private dashboardServiceservice:DashboardService,private router:Router,
     private actionService: NewactionService, private userServiceService:UserService,
     private sanitizer: DomSanitizer,private customersService:CustomersService, 
     private teamServiceservice:TeamService, private fb:FormBuilder, private msSector:MsSectorService, 
     private visitService:VisitService, private notificationService:NotificationsService ) {
       this.Program();
      //  this.Visittovalid();
       this.actions_plan_members = this.fb.group({
        'member': ['', Validators.required]
      });
      this.actions_plan_members.controls['member'].setValue("ALL", {onlySelf: true});
      this.actions_plan_customers = this.fb.group({
        'member': ['', Validators.required]
      });
      this.actions_plan_customers.controls['member'].valueChanges.subscribe(el=>{
        this.indicatorsActionsPlan(el)
      })
      
      this.visit_management_message = this.fb.group({
        'message': ['', Validators.required]
      });
      // this.actions_plan_customers.controls['member'].setValue("ALL", {onlySelf: true});
      
  }
  loading_indicator:boolean=true;
  //CALENDAR VARS
  list:any[]=[
    {
      title: "init title",
      start: '2022-05-05 16:00',
      uuid:"init uuid",
      status: "init status",
      commercial:"init commercial",
      customer:"init customer",
      inProgress:true
    }
  ]
  detail_event:any={};
  eventsAll:any[]=[];
  connectedCompany:any;
  mobile:boolean=false;
  medium:boolean=false;
  formatDate(date:Date) { 
    date = new Date(date);
    var stDate = date.getFullYear()+"-"
    if(date.getMonth()<10){
      stDate = stDate+"0"+(date.getMonth()+1);
      
    }else {
      stDate = stDate +(date.getMonth()+1);
    }
    if(date.getDate()<10){
      stDate = stDate+"-0"+date.getDate()
    }else {
      stDate = stDate+"-"+date.getDate();
    }
    
    return stDate;
   }
   currentYear = new Date().getUTCFullYear();
  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.getCustomers();
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      
    }else {
      this.mobile = false;
      if (window.screen.width <= 860) this.medium = true;
    }
    var dateNow = new Date();
      var firstDay = new Date(dateNow.getFullYear(), dateNow.getMonth(), 2);
      var lastDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
      var startDateInput = document.getElementById('startDate') as any;
      var endDateInput = document.getElementById('endDate') as any;
      startDateInput.valueAsDate = firstDay;
      endDateInput.valueAsDate = lastDay;
     
    this.selectAllCommercialsAtStart();
    this.getAllCustomers();
    if(localStorage.getItem("role")=="adm" || sessionStorage.getItem("role")=="adm"){
      this.router.navigate(['../dashboard']);
      if(localStorage.getItem("comp")!=undefined){
        this.connectedCompany = localStorage.getItem("comp")+" Group";
      }else {
        this.connectedCompany = sessionStorage.getItem("comp")+" Group"
      }
    } else if (localStorage.getItem("role")=="asst" || sessionStorage.getItem("role")=="asst"){
      this.router.navigate(['../dash']);
    } else {
      this.router.navigate(['../mydash']);
    }
    this.News();
    this.Indicator();
    // this.getCalendarVisits();
    this.allProgrammsWeek();
    // this.getItSmart();
    var glob = this;
    setTimeout(()=>{
      this.loadScript("../assets/js/modules/modules-weather-and-calendar.js");
      this.loadScript("../assets/plugins/fullcalendar/moment.min.js");
      this.loadScript("../assets/plugins/fullcalendar/fullcalendar.min.js");
      this.loadScript("../assets/plugins/fullcalendar/custom-fullcalendar.advance.js");
      this.loadScript("../assets/js/ui-kit/ui-accordions.js");
      this.loadScript("../assets/js/ui-kit/ui-tooltip-popovers.js");
      this.loadScript("../assets/plugins/sweetalerts/sweetalert2.min.js");
      this.loadScript("../assets/plugins/sweetalerts/custom-sweetalert.js");
      
      this.dashloading=false;
    }, 1000);
    //CALENDAR FUNCTIONS
    $(document).on("click",".fc-day-grid-event, .commercialName, .customerName", function () {
      var clickedBtnID = $(this).find("span").attr('this-date-uuid'); // or var clickedBtnID = this.id
      var selectedEvent = glob.list.find(d => d.uuid== clickedBtnID);
      if(selectedEvent != undefined){
        glob.detail_event = selectedEvent;
        var detail = "";
        //$("#eventDetails").append(detail);
        const myNode = document.getElementById("eventDetails") as any;
        myNode.innerHTML = '';
        const box = $('#eventDetails');
        // box.addClass(selectedEvent.status+"_container")
        const myNodelist = document.getElementById("eventlist") as any;
        myNodelist.innerHTML = '';
        detail +='<div id="blocEvent" class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+selectedEvent.status+
            '_container" style="border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
            '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">'
        if(selectedEvent.commercial_avatar!=null){
          detail += '<img class="images_pop_detail_calendar " src="data:image/png;base64,'+selectedEvent.commercial_avatar+'"'+ 
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/unknown_user.jpg"'+
          '>';
        }
        if(selectedEvent.customer_logo!=null){
          detail += '<img class="images_pop_detail_calendar" src="data:image/png;base64,'+selectedEvent.customer_logo+'"'+
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/logo.jpg"'+
          '>';
        }
        detail += '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.customer+'</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              // MF-1881 — le champ title est tronqué à 2 sujets avec son « +X, voir détail ».
              // L'infobulle montre la LISTE COMPLÈTE, sinon le « voir détail » ne mène nulle part.
              '<b>Visite topics</b>'+
              '<p class=" pr-3"> '+((selectedEvent.topics && selectedEvent.topics.length) ? selectedEvent.topics.join(', ') : '- - -')+
              '<a href="/visite/detail/it;cr='+selectedEvent.uuid+'" class="ml-3 text-primary">Voir détail</a>'+
              '</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.commercial+'</p>'+
            '</div>'+
            '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.start.substring(0,10)+'</p>'+
            '</div>';
            if(selectedEvent.started_at!=null){
              var startedAt =formatDate(selectedEvent.started_at,'dd-MM-yyyy à HH:mm','en-US')
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/inprogress.gif" style="width: 25px;"><b> Visite démarrée le</b></span>'+
              '<p class="pr-3"> '+startedAt+'</p>'+
            '</div>';
            }
            if(selectedEvent.finished_at!=null){
              var finishedAt =selectedEvent.finished_at;
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal.gif" style="width: 25px;"><b> Visite terminée le</b></span>'+
              '<p class="pr-3"> '+finishedAt+'</p>'+
            '</div>';
            }
            var statusVIsit = null;
            if(selectedEvent.status!=null){
              if(selectedEvent.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(selectedEvent.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(selectedEvent.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(selectedEvent.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              if(selectedEvent.status =="Reported"){
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status_rep_canc.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }else {
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }
            }
            if(selectedEvent.goal!=null && selectedEvent.goal!=""){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 45px;"><b> Objectif de la visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.goal+'</p>'+
            '</div>';
            }
            detail += '</div>';
            if(selectedEvent.finished_at!=null){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">'+
                '<a href="javascript:void(0)" class="text-primary generateRepport" report-uuid="'+selectedEvent.uuid+'">Générer le rapport (pdf)</a></div> '
            }
        setTimeout(()=>{
          $('#detail_event').modal('show');
          $("#eventDetails").append(detail);
          detail = "";
        },500);
      }
    });
    setTimeout(()=>{
      $(document).on("click",".fc-more-cell", function () {
        for(let event of glob.list){
          var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
          if(event.inProgress && ev != null){
            var parenthyper = ev.parentElement;
            parenthyper.parentElement.classList.add("encours");
          }
        }
      });
    },800);
    $(document).on("click",".generateRepport", function () {
      var clickedFinishedVisit = $(this).attr('report-uuid');
      glob.Pdf(clickedFinishedVisit);
    });
    $(document).on("click",".fc-day-top", function () {
      var clickedColDate = $(this).attr('data-date'); // or var clickedBtnID = this.id      
      var selectedEvent = glob.list.filter(d => d.start.includes(clickedColDate));
      if(selectedEvent.length>0){
        this.noVisitCalendarDay=false;
        const myNode = document.getElementById("eventlist") as any;
        myNode.innerHTML = '';
        $('#eventsOfDay').modal('show');
        // setTimeout(()=>{
          this.eventsAll = selectedEvent;
          var list = "";          
          for(var ev of this.eventsAll){
            list +='<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+ev.status+
            '_container" style="border:3px solid #805dca;color:black;border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
              '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">';
              if(ev.commercial_avatar!=null){
                list += '<img class="images_pop_detail_calendar_list " src="data:image/png;base64,'+ev.commercial_avatar+'"'+ 
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/unknown_user.jpg"'+
                '>';
              }
              if(ev.customer_logo!=null){
                list += '<img class="images_pop_detail_calendar_list" src="data:image/png;base64,'+ev.customer_logo+'"'+
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/logo.jpg"'+
                '>';
              }
              list += '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
                '<p class=" pr-3"> '+ev.customer+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                // MF-1881 — liste complète des sujets dans l'infobulle.
                '<b>Visite topics</b>'+
                '<p class=" pr-3"> '+((ev.topics && ev.topics.length) ? ev.topics.join(', ') : '- - -')+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
                '<p class="pr-3"> '+ev.commercial+'</p>'+
              '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
                '<p class="pr-3"> '+ev.start.substring(0,10)+'</p>'+
              '</div>';
              if(ev.goal!=null && ev.goal!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 35px;"><b> Objectif de la visite</b></span>'+
                '<p class="pr-3"> '+ev.goal+'</p>'+
              '</div>';
              }
              var statusVIsit = null;
              if(ev.status!=null){
              if(ev.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(ev.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(ev.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(ev.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
              '<p class="pr-3"> '+statusVIsit+'</p>'+
            '</div>';
            }
              list += '</div>';
              if(ev.finished_at!=null && ev.finished_at!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 mt-2" style="display: inline-grid;top: -14px;text-align: center;">'+
                '<span><img src="assets/img/suivitim_img/pdf.gif" style="width: 30px;"><b> <a href="javascript:void(0)" class="text-primary '+
                'generateRepport" report-uuid="'+ev.uuid+'">Générer le rapport</a></b></span></div>';
              }
              
          }
          $("#eventlist").append(list);
        // },1000);
      }
    });

    $(document).on("click",".fc-agendaDay-button", function () {
      if (window.matchMedia('screen and (max-width: 768px)').matches) {
        var testarray = (document).getElementsByClassName("fc-event-container") as any;
        for(var i = 0; i < testarray.length; i++){
          testarray.item(i).status += " display_content";
        }
          
      }
    })
    

    // NOTIFS CA ///////////////
    this.getAllNotifications();
    setInterval(() => this.getAllNotifications(), 120000);
  }
  noVisitCalendarDay:boolean=false;
  notify(style:any) {
    $.notify({
        title: 'Email Notification',
        text: 'notification test',
        image: "<img src='assets/img/boy.png'/>"
    }, {
        style: 'metro',
        className: style,
        autoHide: false,
        clickToHide: true
    });
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  showProgramme(){
    this.programmLoading =true;
    setTimeout(()=>{
      this.programmLoading =false;
    }, 1000);
  }
  showRapport(){
    this.rapportLoading =true;
    setTimeout(()=>{
      this.rapportLoading =false;
    }, 1000);
  }
  index:any;
  newToValidate:any =0;inprogressIndicator:number=0;
  Indicator(){
    this.dashboardServiceservice.getIndicator();
    this.dashboardServiceservice.indicatorSubject.subscribe(
      ( data: any ) => {
        if(data.code =="274ee1523f1ddeae2ed36ad28df97c39"){
          this.inprogressIndicator = data.indicators.inProgress;
          this.prospects = data.indicators.prospects;
          this.customers = data.indicators.customers;
          this.newToValidate = data.indicators.visits_to_validate;
          this.commercial = data.indicators.last_visit.commercial;
          this.datevisite = data.indicators.last_visit.date_visit;
          this.company = data.indicators.last_visit.company;
        }this.loading_indicator = false;
      },
    ) 
  }
  
  News(){
    this.dashboardServiceservice.getNews();
    this.dashboardServiceservice.newsSubject.subscribe(
      ( data: any ) => {        
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.news = data.news.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
        }
        this.teamPlanLoading=false;
      })
  }
  newslist:any;
  Newslist(){
    this.dashboardServiceservice.getNewslist();
    this.dashboardServiceservice.newslistSubject.subscribe(
      ( data: any ) => {
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.newslist = data.news.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
          
        }this.rapportLoading =false;
      })
  }
  addOrUpdateLoading:boolean = false;
    Pdf(id_visit:any){
      this.addOrUpdateLoading = true;
      this.dashboardServiceservice.getPdf(id_visit);
      this.dashboardServiceservice.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
        const source = `data:application/pdf;base64,`+data.report;
        const link = document.createElement("a");
        link.href = source;
        link.download = data.report_filename;
        link.click();
        this.addOrUpdateLoading = false;

        $("#successSave").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#successSave").hide();
              }, 5000);
        }else{
          $("#error").show();
            $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#error").hide();
            }, 5000);
        }
      },)
    }
    getDetailrapport(opt:any){      
      this.detailrapport = opt;
    } 
    visit:any
    countPlanned:string="";
    percentage_finish:any;
    noPlan:number =0;
    commercialsToLaunch:any[]=[];
    Program(){
      this.noPlan=0;
      this.dashboardServiceservice.getProgram();
      this.dashboardServiceservice.programSubject.subscribe(
      ( data: any ) => {
        if(data.code =="a3012ec200215ec0fb7a2b3744911348"){          
          this.countPlanned = data.countPlanned;
          this.commercials = data.commercials;                    
          this.percentage_finish =data.percentage_finish;
          for(let com of this.commercials){
            // if(com.visits == 0){
              this.noPlan = this.noPlan +1;
              this.commercialsToLaunch.push(com);
            // }
          }
        }        
        this.teamPlanLoading = false;
      })
    }
    getPlannifiedVisites(): any{
      if(parseInt(this.countPlanned) <= 1){
        return `${this.countPlanned} Visite planifiée`;
      }else if((parseInt(this.countPlanned) > 1)){
        return `${this.countPlanned} Visites planifiées`;
      }
    }
    program:any;
  teamPlanLoading:boolean=true;
  programLoading:boolean=true;
  Programe(uuid:any){
    this.programLoading=true;
    this.teamServiceservice.getPrograme(uuid);
    this.teamServiceservice.programSubject.subscribe(
      ( data: any ) => {if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          this.program = data.planning;
          this.programLoading=false;
        }
      },
    )  
  }
  commercialid:any;
  fullname_commercial:any;
  getTeamid(commercial:any){
    this.commercialid = commercial.commercial;
    this.fullname_commercial = commercial.commercial_fullname; 
    this.Programe(this.commercialid);
    
  } 
  
  addeventtocalendar(){
    for(var event of this.list){
      var daycase = document.querySelector("tr td.fc-day-top[data-date='"+event.start+"']")as any;
      if(daycase != null){
        daycase.innerHTML='<a class="fc-day-grid-event fc-h-event fc-event fc-start fc-end fc-event--blue this-date" this-data="'+event.title+'">'+
        "<div class='fc-content' data-container='body' data-html='true' data-placement='top'>"+"<span class='fc-title'>"+event.title+"</span>"
      }
      
    }
  }
  calendarLoading:boolean=true;
  customerNotAffected:any[]=[];
  getCalendarVisits(){
    var startDate:any = document.getElementById('startDate') as HTMLInputElement;
    var endDate:any = document.getElementById('endDate') as HTMLInputElement;
    
    var startDateValue = startDate.value;
    var endDateValue = endDate.value;
    
    if(startDate.value=="" && endDate.value==""){
      var dateNow = new Date();
      var firstDay = new Date(dateNow.getFullYear(), Number(dateNow.getMonth()), 1);
      var lastDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
      startDateValue =firstDay;
      endDateValue = lastDay;
    }
    
    if(startDateValue!="" && endDateValue!=""){
      
      var glob = this;
      this.calendarLoading=true;
      this.dashboardServiceservice.getVisitsCalendar(startDateValue,endDateValue);
      this.dashboardServiceservice.calendarSubject.subscribe(
        ( data: any ) => {          
          if(data.code =="0d7cf8bfb6a3d0d3c57e26777021b1e6"){
            this.list = data.visits;
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth();
            var d = today.getDate();
            setTimeout(()=>{
              $('#c').fullCalendar({
                  header: {
                      left: "prev,next",
                      center: "title",
                      right: "month,agendaWeek,agendaDay"
                  },
                  editable: false,
                  responsive:true,
                  droppable: false, // this allows things to be dropped onto the calendar
                  eventLimit: true,
                  dayMaxEvents: 30,
                  buttonText: {
                      today:    "Aujourd'hui",
                      month:    'mois',
                      week:     'semaine',
                      day:      'jour',
                      allDay: 'jours'
                  },
                  dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                  dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                  monthNamesShort:['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui',
                      'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'],
                  monthNames:['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                  timeFormat: "",
                  events: glob.list
              });
              setTimeout(()=>{
                for(let event of glob.list){
                  var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
                  if(event.inProgress && ev!=null){
                    var parenthyper = ev.parentElement;
                    parenthyper.parentElement.classList.add("encours");
                  }
                }
              }, 1000);
              startDate = document.getElementById('startDate') as HTMLInputElement;
              endDate= document.getElementById('endDate') as HTMLInputElement;
              var columnCalendar = document.querySelector('[data-date="'+startDate.value+'"]') as HTMLElement;
              columnCalendar!.style.backgroundColor="#d7fff2";
              var columnCalendar = document.querySelector('[data-date="'+endDate.value+'"]') as HTMLElement;
              columnCalendar!.style.backgroundColor="#d7fff2";
              
              for (var d:any = new Date(startDate.value); d <= new Date(endDate.value); d.setDate(d.getDate() + 1)) {
                var stringDate = this.formatDate(d);
                var columnCalendar = document.querySelector('[data-date="'+stringDate+'"]') as HTMLElement;
                columnCalendar!.style.backgroundColor="#d7fff2";
              }
            }, 800);
            setTimeout(()=>{
              this.addeventtocalendar();
            }, 2000);
            this.calendarLoading=false;
          }else {
            this.calendarLoading=false;
          }
        },
      ) 
    }
    // if(this.counter==0){
    //   this.counter++;
      
    // }

  }
  visittovalid:any[]=[];
  loading_visittovalid:boolean=true;
  Visittovalid(){
    this.visittovalid = [];
    this.loading_visittovalid=true;
    $('#alter_pagination').DataTable().destroy();
    this.dashboardServiceservice.getVisittovalid();
    this.dashboardServiceservice.visittovalidSubject.subscribe(
      ( data: any ) => {
        if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
          this.visittovalid = data.visits;
          this.visittovalid.forEach(visit => {
            this.msSector.getSector(this.token,visit.visit_customer_sector).subscribe(
              (sectorLabel: any) => {
                visit.visit_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollY": '300px',
              "scrollX": 'auto',
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        }
        this.loading_visittovalid=false;
      },
    )  
  }
  motifRefusVisit:any=null;
  messageResponse:any=null;
  allValidateInProgress:boolean = false;allRefuseInProgress:boolean = false;
  allInProgress:boolean=false;
  validateVisits(uuid:any,action:any){
    // this.motifRefusVisit= document.getElementById("motifArea") as HTMLTextAreaElement;
    this.allInProgress = true;
    var uuids:any[]=[];
    if(uuid != null && uuid != undefined) {
      uuids.push(uuid);
    }else {
      for (let value of Object.values(this.visittovalid)) {
        uuids.push(value.visit);
      }
    }
    if(action=="723634aa8cde73188d4661bb3fe81ce4" && this.motifRefusVisit==null){
      this.motifRefusVisit="Réfusée !";
      this.allRefuseInProgress=true;
    }else {
      this.allValidateInProgress=true;
    }
    this.dashboardServiceservice.validateVisits(uuids,action,this.motifRefusVisit);
    this.dashboardServiceservice.validationVisitsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="aaeb81b0d3c04d5fa7671d4eebde40a4"){
          this.messageResponse = data.message;
          this.motifRefusVisit = null;
          this.allInProgress = false;
          uuids = [];
          if(uuid!=null && action=="f9ab05454998236921a6b0e281fae632"){
            $("#"+uuid).html("Validée");
          }else if(uuid!=null && action=="723634aa8cde73188d4661bb3fe81ce4"){
            $("#"+uuid).html("Réfusée");
          }else {
            (<any>$('#newvisitmodal')).modal('hide');
          }
          // this.Visittovalid();
          this.allValidateInProgress=false;
          this.allRefuseInProgress=false;
          this.Indicator();
        }
        this.Indicator();
      },
    )  
  }

  managementVisitsLoading:boolean=false;
  classesIndicators!:any[];
  allClassesCustomers:any[]=[];
  selectedCommercialManagement:any=null;
  // To Refresh cards suggestions
  uuidManageSuggestion:any;fullnameManageSuggestion:any;elementEventManage:any
  // getVisitsManagement(commercial:any,fullname:any, event:any) {
  //   // event.target.preventDefault();
  //   this.elementEventManage = event;
  //   this.uuidManageSuggestion = commercial;
  //   this.fullnameManageSuggestion = fullname;
  //   // TO SELECT COMMERCIAL BUTTON //////////////
  //   var ritem = event.target.closest('li');
  //   var elements = document.getElementsByClassName('commercial_zone');
  //   for (var i:any = 0; i < elements.length; i++) {
  //     elements[i]?.closest('li')?.classList.remove('active');
  //     elements[i]?.closest('li')?.classList.add('inactif');
  //   }
  //   setTimeout(()=>{
  //     ritem.className += " active";
  //   }, 200);
  //   this.selectedCommercialToNotify=fullname;
  //   this.selectedCommercialManagement = fullname;
  //   this.managementVisitsLoading=true;
  //   this.dashboardServiceservice.getVisitsManagement(commercial);
  //   this.dashboardServiceservice.visitsManagement.subscribe(
  //     ( data: any ) => {          
  //         this.customerNotAffected = data.customersNotAffected;
  //         if(data.code=="1678347b5188d971b5f92362d1142daf"){
  //           this.classesIndicators = data.classes;
  //           this.allClassesCustomers=[];
  //           var ourCommercial = this.commercials.find((obj) => {
  //             return obj.commercial_fullname === fullname;
  //           });
  //           for (let classe of this.classesIndicators) {
  //             if(classe?.cutsomers!=null && classe?.cutsomers.length>0){
  //               for (let customer of classe?.cutsomers) {
  //                 if(customer.affectedToMe || customer.affectedToMe==null){
  //                   customer.classe = classe.classe;
  //                   let planifiedThisWeek = ourCommercial.visits.find((i: any) => i.customer.customer_rs === customer.social);
                    
  //                   if(planifiedThisWeek!=null && planifiedThisWeek!=undefined){
  //                     customer.planned = true;
  //                   }else {
  //                     customer.planned = false;
  //                   }
  //                   if(customer.countPeerMonth == 0) {
  //                     if (customer.countPeerYear == 0) {
  //                       customer.order = 1;
  //                     } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
  //                       customer.order = 2;
  //                     } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
  //                       customer.order = 3;
  //                     }
  //                   } else if (customer.countPeerMonth > 0 && customer.countPeerMonth < customer.correctCountPeerMonth) {
  //                     if (customer.countPeerYear == 0) {
  //                       customer.order = 4;
  //                     } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
  //                       customer.order = 5;
  //                     } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
  //                       customer.order = 6;
  //                     }
  //                   } else if(!(customer.countPeerMonth < customer.correctCountPeerMont)) {
  //                     if (customer.countPeerYear == 0) {
  //                       customer.order = 7;
  //                     } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {  
  //                       customer.order = 8;
  //                     } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
  //                       customer.order = 9;
  //                     }
  //                   } else {
  //                     customer.order = 10;
  //                   }
  //                   this.allClassesCustomers.push(customer);                    
  //                 }
  //               }
  //             }
  //           }
  //         }
  //         this.allClassesCustomers = this.allClassesCustomers.sort((a:any, b:any) => (a.order - b.order));
  //         var copyToReverse = this.allClassesCustomers.sort((a:any, b:any) => (a.indexNum - b.indexNum));
  //           for (let customer of copyToReverse) {              
  //             if(customer.planned){
  //               if(customer.index!=null && customer.index != undefined){
  //                 var splitted = customer.index.split("/", 2); 
  //                 var deplacedCustomer = customer;
  //                 deplacedCustomer.index =splitted[0]+"/"+splitted[1];                  
  //                 if(Number(this.allClassesCustomers.indexOf(customer))-1 != Number(splitted[0])){
  //                   // this.allClassesCustomers = this.allClassesCustomers.filter(i => i.index === this.allClassesCustomers.indexOf(customer));
  //                   this.allClassesCustomers.splice(this.allClassesCustomers.indexOf(customer), 1);//remove element from array
  //                 }
  //                 let existing = this.allClassesCustomers.find((i: any) => i.social === customer.social);
  //                   if(existing!=undefined){
  //                   this.allClassesCustomers.splice(this.allClassesCustomers.indexOf(existing), 1);
  //                 }
  //                 this.allClassesCustomers.splice(Number(splitted[0])-1, 0, deplacedCustomer);
  //               }
  //             }
  //           }
  //           this.managementVisitsLoading=false;          
  //     },
  //   ) 
  // }
customersToVisit:any[]=[];
  selectedClassModal:any;
  selectCustomersToVisit(classe:any){
    this.customersToVisit = classe.cutsomers;    
    this.selectedClassModal = classe.classe;
    $('.icon_click_here').delay(300).fadeIn(2000);  
    setTimeout(()=>{
      $('.icon_click_here').delay(300).fadeOut(2000);
    }, 3000);
  }
  //classesIndicators!:any[];
  async getIndicatorsClassesCustomers(commercial:any,fullname:any, event:any){
    this.managementVisitsLoading = true;
    this.dashboardServiceservice.getVisitsManagement(commercial);
    this.dashboardServiceservice.visitsManagement.subscribe(
      async ( data: any ) => {   
        if(data.code=="1678347b5188d971b5f92362d1142daf"){
          this.classesIndicators = data.classes;
          // Extraire customerUuid et caTarget de tous les clients
          const customersWithTarget = this.classesIndicators
            .reduce((acc: any[], classe) => {
              if (classe.cutsomers && classe.cutsomers.length > 0) {
                const mapped = classe.cutsomers.map((customer: any) => ({
                  customerUuid: customer.customer,
                  caTarget: customer.caTarget
                }));
                return acc.concat(mapped);
              }
              return acc;
            }, []);
          this.processCustomersAfterRevenueUpdate();
          await this.refreshCustomersPrioritizationWithCa(customersWithTarget,commercial);
          this.allClassesCustomers=[]

          this.processCustomersAfterRevenueUpdate();
        }
      },
    )  
  }
  refreshCustomersPrioritizationWithCa(customers: { customerUuid: string; caTarget: number }[],commercial:any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.customersService.getCustomersSuggestionsByRevenue(customers,commercial).subscribe(
        (response: any) => {   
          // Remplacer directement les classes (déjà triées par l'API)
          this.classesIndicators = response.classes;
          // Extraire tous les clients (déjà triés et indexés par l'API)
          this.allClassesCustomers = this.classesIndicators
            .reduce((acc: any[], classe: any) => {
              if (classe.cutsomers && classe.cutsomers.length > 0) {
                const customersWithClass = classe.cutsomers.map((customer: any) => ({
                  ...customer,
                  classe: classe.classe
                }));
                return acc.concat(customersWithClass);
              }
              return acc;
            }, []);
          resolve();
          this.managementVisitsLoading = false;
        },
        (error: any) => {
          console.error('Error:', error);
          this.managementVisitsLoading = false;
          reject(error);
        }
      );
    });
  }
  // ADAPTATION DE LA LISTE FINALE 
  processCustomersAfterRevenueUpdate() {
    this.allClassesCustomers = [];
    
    // Map de priorité des classes
    const classPriority: { [key: string]: number } = {
      'Classe A': 1,
      'Classe B': 2,
      'Classe C': 3,
      'Classe D': 4
    };
    
    for (let classe of this.classesIndicators) {
      if (classe?.cutsomers != null && classe?.cutsomers.length > 0) {
        for (let customer of classe?.cutsomers) {
          if (customer.affectedToMe || customer.affectedToMe == null) {
            customer.classe = classe.classe;
            customer.classPriority = classPriority[classe.classe] ?? 5;
            // Calculer le order basé sur les visites
            if (customer.countPeerMonth == 0) {
              if (customer.countPeerYear == 0) {
                customer.order = 0;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 1;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 2;
              }
            } else if (customer.countPeerMonth > 0 && customer.countPeerMonth < customer.correctCountPeerMonth) {
              if (customer.countPeerYear == 0) {
                customer.order = 3;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 4;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 5;
              }
            } else if (!(customer.countPeerMonth < customer.correctCountPeerMonth)) {
              if (customer.countPeerYear == 0) {
                customer.order = 6;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 7;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 8;
              }
            } else {
              customer.order = 9;
            }
            
            this.allClassesCustomers.push(customer);
          }
        }
      }
    }
    
    // TRI PRINCIPAL: Classe > CA Objectif défini > CA Réalisé > CA à récupérer > Visites
    this.allClassesCustomers.sort((a: any, b: any) => {
      // 1. Par classe
      const classCompare = (a.classPriority ?? 5) - (b.classPriority ?? 5);
      if (classCompare !== 0) return classCompare;

      // 2. Clients AVEC CA Objectif avant SANS CA Objectif
      const hasTargetA = (a.caTarget ?? 0) > 0 ? 0 : 1;
      const hasTargetB = (b.caTarget ?? 0) > 0 ? 0 : 1;
      if (hasTargetA !== hasTargetB) return hasTargetA - hasTargetB;

      // 3. Clients avec CA encore à récupérer (caToGet > 0) avant ceux qui ont atteint leur objectif
      const hasCAToGetA = (a.caToGet ?? 0) > 0 ? 0 : 1;
      const hasCAToGetB = (b.caToGet ?? 0) > 0 ? 0 : 1;
      if (hasCAToGetA !== hasCAToGetB) return hasCAToGetA - hasCAToGetB;

      // 4. countPeerMonth = 0 en priorité (au sein du même groupe)
      const notVisitedMonthA = a.countPeerMonth === 0 ? 0 : 1;
      const notVisitedMonthB = b.countPeerMonth === 0 ? 0 : 1;
      if (notVisitedMonthA !== notVisitedMonthB) return notVisitedMonthA - notVisitedMonthB;

      // 5. Par CA réalisé croissant (0 en priorité)
      const caRealizedA = a.caRealized ?? 0;
      const caRealizedB = b.caRealized ?? 0;
      if (caRealizedA !== caRealizedB) return caRealizedA - caRealizedB;

      // 6. Par CA à récupérer décroissant (plus grand caToGet = plus urgent)
      const caToGetA = a.caToGet ?? 0;
      const caToGetB = b.caToGet ?? 0;
      if (caToGetA !== caToGetB) return caToGetB - caToGetA; // ✅ décroissant

      // 7. Par order (visites)
      return (a.order ?? 9) - (b.order ?? 9);
    });

    // Simplement recalculer les index après le tri (sans déplacer)
    this.allClassesCustomers.forEach((customer: any, index: number) => {
      customer.index = (index + 1) + "/" + this.allClassesCustomers.length;
    });  
  }
  reverseArray(array:any[]) {
    var newArr = [],
        inArr = array.slice();    // take copy of primitive values

    while (inArr.length) {        // check decrementing length
        newArr.push(inArr.pop());
    }
    return newArr;
  }
  smartObject:any;smartOldVisits:any[]=[];smartReportedVisits:any[]=[];smartLessVisits:any[]=[];
  smartLoading:boolean=true;
  getItSmart(){
    this.smartLoading=true;
    this.dashboardServiceservice.smartGestion();
    this.dashboardServiceservice.smartSubject.subscribe(
      ( data: any ) => {
        if(data.code =="6a4cea57c0b35a7c7232fb559cfe34e1"){
          this.smartLoading=false;
          this.smartOldVisits = data.smart.oldVisits.reverse();
          this.smartReportedVisits = data.smart.reportedVisits[0].team;
          this.smartLessVisits = data.smart.lessVisitsCommercials;
          this.smartOldVisits = data.smart.oldVisits;
          
        }else {
          this.smartLoading=false;
        }
      },
    )  
  }

  visitsInprogress:any[]=[];
  loading_visitsInProgress:boolean=true;
  VisitsInprogress(){
    this.visitsInprogress = [];
    this.loading_visitsInProgress=true;
    this.dashboardServiceservice.getVisitsInprogress();
    this.dashboardServiceservice.visitsInprogressSubject.subscribe(
      ( data: any ) => {
        if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
          this.visitsInprogress = data.visits;
        }
        this.loading_visitsInProgress=false;
      },
    )  
  }
  loadingReviveCommercials:boolean=false;
  successRelance:number=0;
  comment_visit:any="";
  loading_send_comment:boolean=false;
  responses:any[]=[];
  sendResponseToCom(visit:any){
    this.visitsInprogress = [];
    this.loading_send_comment=true;
    var responseVisit = {
      message:this.comment_visit
    }
    this.dashboardServiceservice.requestResponseVisit = responseVisit;
    this.dashboardServiceservice.sendResponseVisit(visit);
    this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
      ( data: any ) => {
        // if(data.code =="8b77ef64aa7ec8a8490ba33fff2f249b"){
        //   this.visitsInprogress = data.visits;
        // }
        this.loading_send_comment=false;
      },
    )
  }

  verifylenghtCommentVisit(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#count-comment-visit").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit").html("<span style='color:red'"+toshowNumber+"</span>");
      }
      if(len<=5000){
        $("#count-comment-visit-upd").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit-upd").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#count-comment-visit").html("<span style='color:green'><span>0/5000</span></span>");
      $("#count-comment-visit-upd").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }
  messages:any[]=[];
  loading_messages_visit:boolean=false;
  getMessagesVisitTerminated(visit:any){
    this.messages = [];
    this.loading_messages_visit=true;
    this.dashboardServiceservice.getMessagesVisit(visit);
    this.dashboardServiceservice.getMessagesVisitSubject.subscribe(
      ( data: any ) => {
        this.loading_messages_visit=false;
        if(data.code=="d80c758c95256db1f67684948800447d") {
          this.messages = data.messagesVisit;
          // this.loading_messages_visit=false;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          
        }else {
          this.messages = [];
          // this.loading_messages_visit=false;
        }
        
      },
    )
  }
  sending: boolean = false;
  sendNewMessage(visit:any){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }
    
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.dashboardServiceservice.requestResponseVisit = requestBody;
      this.dashboardServiceservice.sendResponseVisit(visit);
      this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
        ( data: any ) => {
          this.loading_messages_visit=false;
          if(data.code=="292d9f0775864378afb843227b9209b5") {
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $('#messageText').val("");
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.sending = false;
        },)
    }
    
  }

  programs:any[]=[];
  programsWeekLoading:boolean=false;
  daysOfWeek:any[]=["lundi","mardi","mercredi","jeudi","vendredi"];
  indicatorsVisitsOfWeek:number=0;
  commercial_maps:any[]=[];
  allProgrammsWeek(){
    this.programsWeekLoading = true;
      //this.fullname_commercial = commercial.commercial_fullname; 
      this.teamServiceservice.getAllProgramsWeek();
      this.teamServiceservice.allProgramSubject.subscribe(
        ( data: any ) => {
          
          if(data.code =="a3012ec200215ec0fb7a2b3744911348"){             
             for(let commercial of data.planning){
              var pointsMaps:any[]=[];
              commercial.hasMaps = false;
                for(let plan of commercial.planning){
                  if(plan.visits != null && plan.visits.length>0){
                    this.indicatorsVisitsOfWeek = this.indicatorsVisitsOfWeek + plan.visits.length;
                  }
                  if(plan.cities_to_maps_visit!=null && plan.cities_to_maps_visit!=undefined){
                    for(let pointVisit of plan.cities_to_maps_visit){
                      var point = {
                        id:pointVisit.city,
                        title:pointVisit.city,
                        customer: plan.visits[plan.cities_to_maps_visit.indexOf(pointVisit)].customer.customer_rs,
                        latitude:parseFloat(pointVisit.altitude),
                        longitude:parseFloat(pointVisit.longitude)
                      }
                      pointsMaps.push(point)
                    }
                    if(plan.cities_to_maps_visit.length!=0){
                      commercial.hasMaps = true;
                    }
                  }
                }
                commercial.customers = pointsMaps;
                if(commercial.hasMaps){
                  this.commercial_maps.push(commercial);
                }
                // this.initMapsCommercials(data.planning.indexOf(commercial),pointsMaps);
             }
            // this.programLoading=false;
            this.programs = data.planning;                        
          }
          this.programsWeekLoading = false;
        },
      )  
    
  }
  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit, null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  } 
  downloadPicture(event:any,visit:any,base:any){
    
    if(event.target != null){
      var datevisit = JSON.stringify(visit.visit_created_at).slice(0,11)
      event.target!.setAttribute('href', 'data:image/jpg;base64,' + base);
      event.target!.setAttribute('download', 'visite_' +visit.report_customer+"_"+visit.commercial+"_"+datevisit+'.jpg');
    }
  }

  initIndicators(index: number){
    if(index==1){
      this.actions_plan_members.controls['member'].setValue("ALL", {onlySelf: true}); 
      this.indicatorsActionsPlan("ALL");
    } else if (index == 2){
      this.actions_plan_customers.controls['member'].setValue("ALL");
    }
  }
  currentBlocIndicator(event:any) {
    event.currentTarget.classList.add("action_plan_active");
    // Get all buttons with class="btn" inside the container
    var btns = document.getElementsByClassName("action_plan_indicator");
    // setTimeout(()=>{
    //   $('.icon_click_here').delay(300).fadeOut(2000);
    // }, 2000);
    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btns.length; i++) {      
      if(btns[i]!=event.currentTarget){
        btns[i].classList.remove("action_plan_active")
      }
    }
    this.actionsPlanRetrieved=false;
  }
  indicators:any;
  loadingIndicatorsPlan:boolean=false;
  indicatorsActionsPlan(uuid:any){
    this.actionsPlanRetrieved = false;
    this.actionsPlan=[];
    $('.icon_click_here').delay(300).fadeIn(2000);  
    this.loadingIndicatorsPlan = true;  
    this.dashboardServiceservice.getActionsPlanIndicators(uuid).subscribe(
      ( data: any ) => {
        this.indicators = data.indicators;        
        this.actionsPlanRetrieved=false;
        setTimeout(()=>{
          this.loadingIndicatorsPlan = false; 
        }, 1000);
        // Get all buttons with class="btn" inside the container
      setTimeout(()=>{
        $('.icon_click_here').delay(300).fadeOut(2000);
      }, 2000);
    },
      error => {
        console.error('There was an error!', error);
      });
  } 
  actionsPlan:any;
  loadingPlanActions:boolean=false;
  actionsPlanRetrieved:boolean=false;
  selected_type_plan_action:any;
  status!:string;
  modal!:string;
  memberOrAllUuid!:string;

  // no_actions_plan_to_show:boolean=false;
  retrieveActionsPlan(status:string,modal:string,memberOrAllUuid:any){
    this.status = status;
    this.modal = modal;
    this.memberOrAllUuid= memberOrAllUuid.member;
    this.actionsPlanRetrieved = false;
    this.actionsPlan=[];
    var id = memberOrAllUuid.member;    
    this.selected_type_plan_action = memberOrAllUuid.member;
    this.loadingPlanActions = true;     
     // Get the indicator value based on the case
     let indicatorValue;
     if (status === "f7222d1de86ad4d56764a2be21b792e2") {
       indicatorValue = this.indicators.actions_in_progress.action_indicator;
     } else if (status === "c3314fb1663806e07c6fe263de9907da") {
       indicatorValue = this.indicators.actions_not_done.action_indicator;
     } else if (status === "6b2ded51d81a4403d8a4bd25fa1e57ee") {
       indicatorValue = this.indicators.actions_done.action_indicator;
     }
     // Check if the indicator value is 0
    if (indicatorValue === 0) {
      // Show empty table directly
      setTimeout(()=>{
        this.loadingPlanActions = false; 
        this.actionsPlanRetrieved = true;
      }, 200);
      this.actionsPlan =[]
      if(modal=="customer"){
        setTimeout(()=>{
          // this.loadingPlanActions = false; 
          (<any>$('#actions_plan_table_customer')).DataTable().destroy();
          (<any>$("#actions_plan_table_customer")).DataTable( {
            "pagingType": "full_numbers",
            "scrollY": '400px',
            "scrollX": '400px',
            order: [[4, 'desc']],
            "scrollCollapse": false,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                  type: 'line',
                  width: '60',
                  height: '20',
                  lineColor: '#1a73e9',
                  fillColor: '#c2d5ff',
                  spotColor: 'transparent',
                  minSpotColor: 'transparent',
                  maxSpotColor: 'transparent',
                  highlightSpotColor: 'transparent',
                  highlightLineColor: 'transparent',
              });
            }
          });
        }, 800);
      }else {
        setTimeout(()=>{
          (<any>$('#actions_plan_table')).DataTable().destroy();
          
          (<any>$("#actions_plan_table")).DataTable( {
            "pagingType": "full_numbers",
            "scrollY": '400px',
            "scrollX": '400px',
            order: [[4, 'asc']],
            "scrollCollapse": false,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                  type: 'line',
                  width: '60',
                  height: '20',
                  lineColor: '#1a73e9',
                  fillColor: '#c2d5ff',
                  spotColor: 'transparent',
                  minSpotColor: 'transparent',
                  maxSpotColor: 'transparent',
                  highlightSpotColor: 'transparent',
                  highlightLineColor: 'transparent',
              });
            }
          });
        }, 800);
      }
    }else{
    this.dashboardServiceservice.getActionsPlan(id,status);
    this.dashboardServiceservice.actionsPlanSubject.subscribe(
      ( data: any ) => {
        if(data.code=="b8f8289ade38c75780d8156c9d8fd624" && data.actions != null){
          this.actionsPlan = data.actions.sort((a:any, b:any) => new Date(a.action_added_at).getTime() - new Date(b.action_added_at).getTime());                       
          setTimeout(()=>{
            this.loadingPlanActions = false; 
            this.actionsPlanRetrieved = true;
          }, 200);
          // this.no_actions_plan_to_show=false;
          if(modal=="customer"){
            setTimeout(()=>{
              // this.loadingPlanActions = false; 
              (<any>$('#actions_plan_table_customer')).DataTable().destroy();
              (<any>$("#actions_plan_table_customer")).DataTable( {
                "pagingType": "full_numbers",
                "scrollY": '400px',
                "scrollX": '400px',
                order: [[4, 'desc']],
                "scrollCollapse": false,
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
                }
              });
            }, 800);
          }else {
            setTimeout(()=>{
              (<any>$('#actions_plan_table')).DataTable().destroy();
              
              (<any>$("#actions_plan_table")).DataTable( {
                "pagingType": "full_numbers",
                "scrollY": '400px',
                "scrollX": '400px',
                order: [[4, 'asc']],
                "scrollCollapse": false,
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
                }
              });
            }, 800);
          }
        }else {
          this.loadingPlanActions = false; 
        }
    })
    }
  }
  generateCsvCommercialLoading:boolean = false;
  generateCsvCustomersLoading:boolean = false;
  generateCsv(status:string,modal:string,memberOrAllUuid:string){
    if(modal=="commercials"){
      this.generateCsvCommercialLoading = true;
    } else {
      this.generateCsvCustomersLoading = true;
    }
    this.dashboardServiceservice.generateCsv(memberOrAllUuid,status).subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,` + data.fileEnv.file;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.fileEnv.fileName;
          link.click();
        }
        this.generateCsvCommercialLoading = false;
        this.generateCsvCustomersLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.generateCsvCommercialLoading = false;
        this.generateCsvCustomersLoading = false;
      }
      )
  }

  clientsOfAction: any[] = [];
  customersActionSubscription!: Subscription;
  getCustomers(){
    this.customersActionSubscription = this.actionService.getCustomersByAction().subscribe(
      (res: any) => {
        if(res.code == "260617389ff7d4751df0cd284e76f1d6"){
          this.clientsOfAction = res.customers;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  clientsOfSector:any[]=[];
  loadingCustomers:boolean=false;
  getAllCustomers(){
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        var newArrayAllCustomers:any[] = [];
        if(data.customers != null && data.customers != undefined){
          for(let cust of data.customers){
            var sites:any[]=[];
            var site:any = {
              city:cust.customer_city,
              uuid:cust.city,
              customer:cust.customer
            }
            sites.push(site)
            var customer = {
              rs_customer:cust.customer_rs,
              city_uuid:cust.customer_city,
              uuid:cust.customer,
              sites:sites
            }
            newArrayAllCustomers.push(customer);
          }
        }
        setTimeout(()=>{
          this.clientsOfSector = newArrayAllCustomers;
        }, 1000);
      },
    )  
  }

  // SEND MESSAGE NOTIFICATION ABOUT CUSTOMER TO PLANIFY VISIT TO HIM /////////////////////
  selectedNotifCustomer:any=null;
  customerid:any =null;
  message_toCommercial:any;
  selectCustomerNotif(customer:any){
    this.selectedNotifCustomer = customer.social;
    this.customerid = customer.customer;
    this.message_toCommercial = null;
  }
  selectedCommercialToNotify:any;
  loadingMessage:boolean=false;
  sendNewMessageNotif(){
    this.loadingMessage = true;
    var message = this.visit_management_message.controls['message'].value;
    if(message != null && message != ""){
      var requestBody = {
        message:message,
        important:true
      }
      this.customersService.sendMessage(this.customerid, requestBody).subscribe(
        ( data: any ) => {
          this.visit_management_message.reset();
          $('#bloc_'+this.customerid).css("display", "none !important");
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            // $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            // $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
            this.loadingMessage = false;
            const toast = swal.mixin({
              toast: true,
              position: 'top-center',
              showConfirmButton: false,
              timer: 5000,
              padding: '2em'
            });
            $('.notifyCommercial').trigger('click');
            toast({
              type: 'success',
              title: 'Message envoyé à : <b>'+this.selectedCommercialToNotify+'</b>',
              padding: '2em',
            })
          }
          // this.loadingMessages=false;
        },
        error => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }
  // cancelMessageAboutCustomer(e:any){
  //   // e.target.closest('.dropdown-menu').style.display = "none";
  // }
  activeCommercialBtn(event:any){    
    $('.ripple').removeClass('list_ripple');
    event.target.classList.toggle("list_ripple");
  }

  oldClassMap:any=null;
  initMapsCommercials(commercial:any, customers:any[]) {    
    am4core.useTheme(am4themes_animated);
    var glob = this;
    var plots:any = {'ny': {
      size: 8,
      latitude: 33.665850401775806,
      longitude: -7.408924634608298,
      tooltip: {content: "<span class='flaticon-building mr-2' style='font-size: x-large;'></span>" +this.connectedCompany},
      attrs: {
        fill:"#01d3d7"
      },
      text: {content: this.connectedCompany, attrs: {fill: "#fff"}}
    }};
    var links:any = {};
    $.each(commercial.planning, function (id:any, elem:any) {
      if(elem.cities_to_maps_visit != null && elem.cities_to_maps_visit.length>0){
        $.each(elem.cities_to_maps_visit, function (index:any, plan:any) {
          // Check if we have the GPS position of the element
          // Will hold the plot information
          var plot:any = {};
          // Assign position
          plot.latitude = parseFloat(plan.altitude);
          plot.longitude = parseFloat(plan.longitude);
          plot.text = {content: plan.city, attrs: {fill: "#000"}};
          // Assign some information inside the tooltip
          var dateDeplacement:Date = new Date(elem.day_week);
          var date_visit = dateDeplacement.getDate()+ '/' +((dateDeplacement.getMonth() + 1))+ '/' +dateDeplacement.getFullYear();
          var isPinpoint ="";
          if(!plan.isPinpoint){
            isPinpoint = "(position non précise)";
          }else {
            isPinpoint ="";
          }
          plot.tooltip = {
              content: "<span class='flaticon-location mr-2' style='font-size: x-large;'></span> Déplacement vers <span style='font-weight:bold;'>" +plan.city +
                        "</span> <span style='font-size:smaller;'>"+isPinpoint+"</span> pour la visite de : <span style='font-weight:bold;'>" +elem.visits[index].customer.customer_rs+
                        "</span><br/>Planifiée pour le : <span style='font-weight:bold;'>" + date_visit +"</span>"
          };
          plot.attrs = {
            fill:"#ffa900"
          };
          // Set plot element to array
          plots[elem.cities_to_visit[index]] = plot;

          var link:any = {};
          // Assign position
          link.factor =  -0.3;
          link.between = ['ny', elem.cities_to_visit[index]];
          link.attrs = {
            "stroke-width": 2,
            "stroke": "#01d3d7"
          };
          // Set plot element to array
          links['ny'+elem.cities_to_visit[index]] = link;
        });
      }
    });
    var fullname_splitted = commercial.commercial.toString().split(" "); 
    if(this.oldClassMap==null){
      $(".mapMorocco").addClass("mapcontainer-"+fullname_splitted[0])
    }else {
      $(".mapMorocco").addClass("mapcontainer-"+fullname_splitted[0]).removeClass(this.oldClassMap);
    }
    this.oldClassMap = "mapcontainer-"+fullname_splitted[0];
      setTimeout(()=>{
        var mapW = 508.77;
			  var mapH = 231.44;
        var deletedPlots = "all", 
        opt = {
            animDuration : 1000,
            deletedLinks : "all"
          };
        $(".mapcontainer-"+fullname_splitted[0]).trigger('update', [{}, {}, deletedPlots, opt]);
        var maps = $(".mapcontainer-"+fullname_splitted[0])?.mapael({
          map: {
              name: "morocco"
              , zoom: {
                  enabled: true,
                  maxLevel: 100,
                  init: {
                      latitude: 33.665850401775806,
                      longitude: -10.408924634608298,
                      level: 5
                  },
                  animDuration: 2000
              },
              afterInit: function ($self:any, paper:any, areas:any, plots:any, options:any) {
                $('.mapcontainer-'+fullname_splitted[0]+' .map').unbind("resizeEnd");
                $(window).on('resize', function () {
                  var winW = $(window).width();
                  var winH = $(".map").height();
                  var winRatio = winW / winH;
                  var mapRatio = mapW / mapH;
                  
                  paper.setSize(winW, (mapH * winW) / mapW);
                  if(winRatio > mapRatio){                 
                    paper.setSize((mapW * winH) / mapH, winH);
                  }else{
                    paper.setSize(winW, (mapH * winW) / mapW);
                  }
                  if(glob.mobile){
                    var siY = ((mapW * winH) / mapH)-300;
                    var siX = winH+40;
                  }
                  var winmap = $(".map").width();
                  paper.setSize(winmap, siX);
                }).trigger('resize');
              },
               defaultArea: {
                  attrs: {
                      fill: "#006e93"
                  },
                  attrsHover: {
                      fill: "#888ea8"
                  }
              }
          },
          plots: plots,
          links: links
        });
        
        const cursor:any = document.querySelector('.mapTooltip');
    
        // Custom cursor follow the default cursor
        document.addEventListener('mousemove', e => {
            cursor.setAttribute('style', 'top: '+(e.pageY - 10)+'px; left: ' +(e.pageX - 10)+'px;')
        });

        const circles:any = document.querySelectorAll('circle');
        // Custom cursor change style on hover links
        for(let x of circles) {
          x.addEventListener('mouseenter', () => {
          cursor.classList.add('hover');
          });
          x.addEventListener('mouseleave', () => {
          cursor.classList.remove('hover');
          }); 
        }
      }, 1000);
      // INIT ZOOM TO SHOW ALL MAP
      setTimeout(()=>{
        if(this.mobile){
          $('.mapcontainer-'+fullname_splitted[0]).trigger('zoom', {
            level: 0
          });
        }else {
          $('.mapcontainer-'+fullname_splitted[0]).trigger('zoom', {
            level: 0
          });
        }
        
      }, 2500);
      this.getKpiOfUseSmartSuggestions(commercial);
  }
  initKPIPlanification(){
    const animationDuration = 3000;

    const frameDuration = 1000 / 60;

    const totalFrames = Math.round( animationDuration / frameDuration );

    const easeOutQuad = (t:any) => t * ( 2 - t );

    const animateCountUp = (el:any) => {
      let frame = 0;
      const countTo = parseInt( el.innerHTML, 10 );
      
      const counter = setInterval( () => {
        frame++;

        const progress = easeOutQuad( frame / totalFrames );

        const currentCount = Math.round( countTo * progress );


        if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
          el.innerHTML = currentCount;
        }

        if ( frame === totalFrames ) {
          clearInterval( counter );
        }
      }, frameDuration );
    };

    const countupEls = document.querySelectorAll( '.timer' );
    countupEls.forEach( animateCountUp );
    
  }
  resetMapaelZoom(mapInstance: any): void {
    if (mapInstance && mapInstance.$container) {
      // Vérification que l'instance de carte existe et est valide
      try {
        // Réinitialisation du zoom en utilisant setViewBox avec les valeurs initiales
        mapInstance.setViewBox(
          mapInstance.initialViewBox.x,
          mapInstance.initialViewBox.y,
          mapInstance.initialViewBox.w,
          mapInstance.initialViewBox.h
        );
        
      } catch (error) {
        console.error('Erreur lors de la réinitialisation du zoom de la carte:', error);
      }
    } else {
      console.error('Instance de carte Mapael invalide');
    }
  }
  percentToday:any; visitedCustomerToday:any[]=[];  loadingKpiToday:boolean=true;
  percentThisWeek:any; visitedCustomerThisWeek:any[]=[];  loadingKpiTheWeek:boolean=true;
  percentThisMonth:any; visitedCustomerThisMonth:any[]=[];  loadingKpiTheMonth:boolean=true;
  getKpiOfUseSmartSuggestions(commercial:any){
    this.loadingKpiToday=true;
    this.loadingKpiTheWeek=true;
    this.loadingKpiTheMonth=true;
    // Pour le premier appel
    this.dashboardServiceservice.getKpiSuggestions(commercial.commercialUuid, 'today').subscribe(data => {
      this.percentToday = data.visitsKpi;
      if(data.visitsKpi!=undefined){
        this.loadingKpiToday=false;
        this.initKPIPlanification();
        this.visitedCustomerToday = data.visitsKpi.customers;
        this.percentToday.percentageSuggestionVisits = this.percentToday.percentageSuggestionVisits.toFixed(1);
      }
    });

    // Pour le deuxième appel
    this.dashboardServiceservice.getKpiSuggestions(commercial.commercialUuid, 'week').subscribe(data => {
      this.percentThisWeek = data.visitsKpi;
      if(data.visitsKpi!=undefined){
        this.loadingKpiTheWeek=false;
        this.initKPIPlanification();
        this.visitedCustomerThisWeek = data.visitsKpi.customers;
      }
    });

    // Pour le troisième appel
    this.dashboardServiceservice.getKpiSuggestions(commercial.commercialUuid, 'month').subscribe(data => {
      this.percentThisMonth = data.visitsKpi;
      if(data.visitsKpi!=undefined){
        this.loadingKpiTheMonth=false;
        this.initKPIPlanification();
        this.visitedCustomerThisMonth = data.visitsKpi.customers;
      }
    });
  }

  //#region RELANCE CODES PART
    selectedCommercialUuids: string[] = []; // Liste des UUIDs sélectionnés
    selectAllCommercials: boolean = false;

    openRelaunchModal(): void {
      // S'assurer que tous sont sélectionnés avant d'ouvrir
      this.selectAllCommercialsAtStart();
      this.commercialsToLaunch = this.commercialsToLaunch.map(commercial => ({
        ...commercial,
        selected: true  // ✅ COCHÉ PAR DÉFAUT
      }));
    }
    selectAllCommercialsAtStart(): void {
      if (this.commercialsToLaunch && this.commercialsToLaunch.length > 0) {
        this.selectedCommercialUuids = this.commercialsToLaunch.map(c => c.uuid);
      }
    }

    // Vérifie si un commercial est sélectionné
    isCommercialSelected(uuid: string): boolean {
      return this.selectedCommercialUuids.includes(uuid);
    }

    getSelectedUuids(): string[] {
      return this.commercialsToLaunch
        .filter(c => c.selected === true)
        .map(c => c.commercial);
    }

    //Gère le changement d'état d'un commercial individuel
    toggleCommercial(commercial: any, event: any): void {
      const isChecked = event.target.checked;
      // Mettre à jour l'état
      commercial.selected = isChecked;
    }

    // Envoie la relance aux commerciaux sélectionnés
    sendReviveToPlan(): void {
      if (this.selectedCommercialUuids.length === 0) {
        console.warn('Aucun commercial sélectionné');
        return;
      }
      if(this.getSelectedUuids().length==this.commercialsToLaunch.length){
        this.sendReviveToAll();
      }else {
        this.sendReviveToMembersOfTeam();
      }
    }

    // Réinitialise les sélections (tous cochés par défaut)
    resetSelections(): void {
      this.selectAllCommercialsAtStart();
    }

    // Methode à appeler lors de l'ouverture du modal pour s'assurer que tout est coché par défaut
    openModal(): void {
      this.selectAllCommercialsAtStart();
    }

    sendReviveToAll() {
      // if(this.noPlan>0){
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToCommercials();
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
      // }
    }
    sendReviveToMembersOfTeam() {
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToSelectedCommercials(this.getSelectedUuids());
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
    }
  //#endregion

    alerts:any[]=[];
    loadingAlerts:boolean=true;
    visitsProposed:any=0;
    getAllNotifications(){
      this.loadingAlerts=true;
      this.notificationService.getNotificationsCA().subscribe(data => {
        if(data!=undefined && data.code=="SUCCESS"){
          this.alerts=data.notifications
          this.visitsProposed = this.alerts.find((i:any) => i.type === "VISITE_NON_PLANIFIEE");
          var title ="Aucun";
          var customers:string = "";        
          if(this.visitsProposed?.metadata?.visitCount>1){
            title = "<b>Clients à visiter :</b>";
            // for(let customer of this.visitsProposed?.metadata.customers){
            customers = '<i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>'+this.visitsProposed.metadata.customers.join(' - <i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>');
            // }
          }else {
            if(this.visitsProposed?.metadata?.visitCount>0){
              title = "<b>Client à visiter :</b>";
              customers = '<i _ngcontent-wql-c90="" class="flaticon-building-1 mr-1"></i>' 
                +this.visitsProposed?.metadata?.customers[0];
            }
          }
          const popoverContent = customers || "Aucun client à visiter";
          $('.btn-popover-default'+this.visitsProposed?.type).popover({
              template: '<div class="popover popover-default" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
              title: title,
              content: popoverContent
          });
        }
        this.loadingAlerts=false;
      });
    }
}